
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.857 5.932H2.143c-.79 0-1.429.64-1.429 1.428v10c0 .789.64 1.428 1.429 1.428h15.714c.789 0 1.428-.64 1.428-1.428v-10c0-.789-.64-1.428-1.428-1.428zM.714 11.647h18.571M10 10.217v2.857","stroke":"#339299","stroke-width":"1.429","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.285 5.932a4.286 4.286 0 00-4.286-4.285v0a4.286 4.286 0 00-4.285 4.285","stroke":"#339299","stroke-width":"1.429","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    